import { render, staticRenderFns } from "./AreaSelecter.vue?vue&type=template&id=3cbf8457&scoped=true&"
import script from "./AreaSelecter.vue?vue&type=script&lang=js&"
export * from "./AreaSelecter.vue?vue&type=script&lang=js&"
import style0 from "./AreaSelecter.vue?vue&type=style&index=0&id=3cbf8457&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf8457",
  null
  
)

export default component.exports